module.exports = __webpack_public_path__ + "static/New_Hero_Super-5d14acbff24a66ea55283bde56cd0681.otf";